import { useQuery } from "@tanstack/react-query";
import { useSupabaseClient } from "@/lib/supabase";
import type { CriativoRow } from "../types";

export function useCriativos() {
  const { client, isReady } = useSupabaseClient();
  return useQuery({
    queryKey: ["criativos", "list", isReady],
    enabled: isReady,
    queryFn: async (): Promise<CriativoRow[]> => {
      const { data, error } = await client
        .from("criativos")
        .select(
          "id, label, media_kind, veiculacao, objetivo_input, objetivo_detectado, transcript_text, analysis_payload, ai_job_id, created_at, updated_at",
        )
        .order("created_at", { ascending: false })
        .limit(50);
      if (error) throw new Error(error.message);
      return (data as unknown as CriativoRow[]) ?? [];
    },
  });
}
